import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { createTheme, ThemeProvider as ThemeProviderV5 } from "@mui/material/styles";
import { esES } from "@material-ui/core/locale";
import "./i18n";
import { SnackbarProvider } from "notistack";
import * as serviceWorker from "./serviceWorker";
import "./index.css";
import "@fontsource/montserrat/300.css";
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/700.css";
import App from "./App/App";
import ErrorBoundary from "./App/BIMDigitalTwin/Common/Components/ErrorBoundary";
import Loading from "./App/BIMDigitalTwin/Common/Components/Loading";
import "./styles/colors.css";
import "./styles/fonts.css";

const primaryColor = "#428DC7 !important";
const secondaryColor = "#EDB100";
const fontFamily = "Montserrat, sans-serif";

const theme = createMuiTheme(
    {
        palette: {
            primary: {
                main: primaryColor,
            },
            secondary: {
                main: secondaryColor,
            },
            background: {
                default: "#FFFFFF",
                paper: "#FFFFFF",
            },
        },
        typography: {
            fontFamily: "Montserrat",
            fontSize: 12,
        },
        overrides: {},
    },
    esES
);
const themev5 = createTheme(
    {
        palette: {
            primary: {
                main: primaryColor,
            },
            secondary: {
                main: "#EDB100",
            },
            background: {
                default: "#FFFFFF",
                paper: "#FFFFFF",
            },
        },
        typography: {
            fontFamily: "Montserrat",
            fontSize: 12,
        },
    },
    esES
);

ReactDOM.render(
    <React.StrictMode>
        <ThemeProviderV5 theme={themev5}>
            <ThemeProvider theme={theme}>
                <SnackbarProvider
                    maxSnack={3}
                    anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                    autoHideDuration={4000}
                >
                    <ErrorBoundary errorMessage="Critical error" useSuspense={false}>
                        <Suspense fallback={<Loading useLogo />}>
                            <BrowserRouter>
                                <App />
                            </BrowserRouter>
                        </Suspense>
                    </ErrorBoundary>
                </SnackbarProvider>
            </ThemeProvider>
        </ThemeProviderV5>
    </React.StrictMode>,
    document.getElementById("root")
);

// authService
//     .isAuthenticated()
//     .then((isAuth) => {
//         if (isAuth) {
//             ReactDOM.render(
//                 <React.StrictMode>
//                     <ThemeProvider theme={theme}>
//                         <ErrorBoundary errorMessage="Critical error">
//                             <Suspense fallback={<Loading useLogo />}>
//                                 <BrowserRouter>
//                                     <App />
//                                 </BrowserRouter>
//                             </Suspense>
//                         </ErrorBoundary>
//                     </ThemeProvider>
//                 </React.StrictMode>,
//                 document.getElementById("root")
//             );
//         } else {
//             ReactDOM.render(
//                 <React.StrictMode>
//                     <ErrorBoundary errorMessage="Login error">
//                         <Suspense fallback={<Loading useLogo />}>
//                             <BrowserRouter>
//                                 <Switch>
//                                     <Route
//                                         path={ApplicationPaths.ApiAuthorizationPrefix}
//                                         component={ApiAuthorizationRoutes}
//                                     />
//                                     <AuthorizeRoute path="/" />
//                                 </Switch>
//                             </BrowserRouter>
//                         </Suspense>
//                     </ErrorBoundary>
//                 </React.StrictMode>,
//                 document.getElementById("root")
//             );
//         }
//     })
//     .catch((err) => {});

// Uncomment the line above that imports the registerServiceWorker function
// and the line below to register the generated service worker.
// By default create-react-app includes a service worker to improve the
// performance of the application by caching static assets. This service
// worker can interfere with the Identity UI, so it is
// disabled by default when Identity is being used.
serviceWorker.unregister();
